import { Conduit } from '@campingvision/conduit';
import { authentication } from '../../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}products/skistar/`,
  [],
  [authentication],
  [],
  false,
  30000,
  true,
);

export default {
  /**
   * @returns {AxiosPromise}
   */
  getResorts() {
    return conduit.get('resorts');
  },

  /**
   * @returns {AxiosPromise}
   */
  getAccommodationsByResortId(resortId) {
    return conduit.get(`resorts/${resortId}/accommodations-with-subarea-and-area`);
  },

  /**
   * @returns {AxiosPromise}
   */
  getResortSubareas(resortId) {
    return conduit.get(`resorts/${resortId}/subareas`);
  },

  /**
   * @returns {AxiosPromise}
   */
  importAccommodations(requestBody) {
    return conduit.post('accommodations/import', requestBody);
  },

  /**
   * @returns {AxiosPromise}
   */
  getAccommodationTexts(accommodationId) {
    return conduit.get(`accommodations/${accommodationId}/texts`);
  },

  /**
   * @returns {AxiosPromise}
   */
  getAccommodationImages(accommodationId) {
    return conduit.get(`accommodations/${accommodationId}/images`);
  },

  /**
   * @returns {AxiosPromise}
   */
  activateAccommodationImage(accommodationId, identifier) {
    return conduit.put(
      `accommodations/${accommodationId}/images/${identifier}/update-active-status`,
      { active: true },
    );
  },

  /**
   * @returns {AxiosPromise}
   */
  deactivateAccommodationImage(accommodationId, identifier) {
    return conduit.put(
      `accommodations/${accommodationId}/images/${identifier}/update-active-status`,
      { active: false },
    );
  },

  /**
   * @returns {AxiosPromise}
   */
  deleteAccommodationImage(accommodationId, identifier) {
    return conduit.delete(
      `accommodations/${accommodationId}/images/${identifier}`,
    );
  },

  /**
   * @returns {AxiosPromise}
   */
  unmapAccommodation(xmlChannelProductId) {
    return conduit.delete(`accommodations/xmlChannelProductId/${xmlChannelProductId}/unmap`);
  },

  /**
   * @returns {AxiosPromise}
   */
  getResortAddons(resortId) {
    return conduit.get(`addons/resorts/${resortId}`);
  },

  /**
   * @returns {AxiosPromise}
   */
  updateAddonTwentyExtraId(addon) {
    return conduit.put(
      'addons/update',
      addon,
    );
  },

  /**
   * @returns {AxiosPromise}
   */
  changeSiteOnAccommodation(accommodationSiteId, siteId) {
    return conduit.put(
      `accommodations/imported/by-accommodation-site/${accommodationSiteId}/change-site`,
      {
        siteId,
      },
    );
  },

  /**
   * @param accommodationSiteId
   * @returns {AxiosPromise}
   */
  getAccommodationSiteWithAccommodation(accommodationSiteId) {
    return conduit.get(`accommodations/imported/by-accommodation-site/${accommodationSiteId}`);
  },
};



// WEBPACK FOOTER //
// ./src/services/ski/skistar-service.js